import * as React from 'react';
export const PTSvg = React.forwardRef(function PTSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M6 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4v12Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M14 14H6V2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M5.975 5C7.645 5 9 6.343 9 7.999c0 1.656-1.355 2.999-3.025 2.999C4.324 10.97 3 9.636 3 7.999c0-1.636 1.324-2.97 2.975-2.998V5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M5.94 6a2 2 0 1 1 .12 4 2 2 0 0 1-.12-4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M5 7h2v1.5a1 1 0 1 1-2 0V7Z',
      }),
    ),
  );
});
PTSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PT = {
  category: 'flag',
  colorable: false,
  name: 'PT',
  svg: PTSvg,
};
